import * as z from "zod/v4";

export const getChargebacksInsights = {
  name: "getChargebacksInsights" as const,
  input: z.object({}),
  output: z
    .object({
      totalCount: z.number(),
      totalAmount: z.number(),
      wonCount: z.number(),
      wonAmount: z.number(),
      lostCount: z.number(),
      lostAmount: z.number(),
      currency: z.string(),
    })
    .nullable(),
};
